"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumb = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const Link_1 = require("../../1-inline/Link");
const blockClass = (0, nano_theme_1.drule)({
    fz: '15.6px',
    bdrad: '0.4em',
    lh: '1.4em',
    out: 0,
    bd: 0,
    pd: 0,
    mr: 0,
});
const Breadcrumb = ({ noHover, compact, selected, children, ...rest }) => {
    const styles = (0, context_1.useStyles)();
    const noClick = !rest.to && !rest.onClick;
    const style = {
        fontSize: compact ? '11px' : '13px',
        padding: compact ? '2px 4px' : '4px 8px',
    };
    const link = styles.col.get('link', 'solid-1');
    const linkBg = styles.col.get('link', 'bg-2');
    const positiveFg = styles.positive.fg.toString();
    const positiveBg = (styles.light ? styles.positive.fg.pct(0, -0.5, 0.85) : styles.positive.fg.pct(0, -0.3, -0.65)).toString();
    const className = blockClass(compact
        ? {
            cur: rest.to ? 'pointer' : 'default',
            ...(compact ? nano_theme_1.lightTheme.font.ui2.mid : nano_theme_1.lightTheme.font.ui2.bold),
            col: selected ? link : styles.g(0.5),
            bg: selected ? linkBg : 'transparent',
            '&:hover': {
                col: noClick ? styles.g(0.5) : positiveFg,
                bg: noClick ? 'transparent' : positiveBg,
            },
        }
        : {});
    if (noClick) {
        return (React.createElement("span", { className: (rest.className ?? '') + className, style: style, onMouseDown: rest.onMouseDown }, children));
    }
    return (React.createElement(Link_1.Link, { ...rest, a: !!rest.to, className: (rest.className ?? '') + className, style: style }, children));
};
exports.Breadcrumb = Breadcrumb;
